import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  title: {
    color: "#030F1C",
    fontFamily: "Inter Tight !important",
    fontWeight: "500 !important",
    fontSize: "22px !important",
    lineHeight: "32px !important",
    [theme.breakpoints.down("md")]: {
      fontSize: "18px !important",
      lineHeight: "26px !important",
    },
  },
  subtitle: {
    color: "#646F86",
    fontFamily: "Inter Tight !important",
    fontWeight: "400 !important",
    fontSize: "16px !important",
    lineHeight: "24px !important",
    marginTop: "8px !important",
    marginBottom: "16px !important",
    [theme.breakpoints.down("md")]: {
      fontSize: "14px !important",
      lineHeight: "20px !important",
    },
  },
  container: {
    border: "1px solid #F2F4F7 !important",
    padding: "22px !important",
    backgroundColor: "#F9F9FB !important",
    borderRadius: "8px !important",
    justifyContent: "flex-end !important",
    [theme.breakpoints.down("md")]: {
      padding: "16px !important",
    },
  },
  TextStyle: {
    color: "#202939 ",
    fontFamily: "Inter Tight !important",
    fontSize: "18px !important",
    letterSpacing: "0.5px !important",
    lineHeight: "24px !important",
    fontWeight: "500 !important",
    [theme.breakpoints.down("md")]: {
      fontSize: "16px !important",
    },
  },

  language: {
    fontFamily: "Inter Tight !important",
    color: "#646F86",
    fontSize: "16px !important",
    fontWeight: "400 !important",
    letterSpacing: "0.5px !important",
    lineHeight: "24px !important",
    [theme.breakpoints.down("md")]: {
      fontSize: "14px !important",
      lineHeight: "20px !important",
    },
  },
  imgStyle: { height: "16px" },

  // One compact device card: icon | identity (flexes) | Sign out (fixed).
  deviceCard: {
    display: "flex !important",
    alignItems: "center !important",
    gap: "12px !important",
    padding: "12px !important",
    marginTop: "12px !important",
    border: "1px solid #EAECF0 !important",
    borderRadius: "10px !important",
    backgroundColor: "#FFF !important",
  },
  deviceIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    width: "32px",
    height: "32px",
    borderRadius: "8px",
    backgroundColor: "#F2F4F7",
  },
  deviceMeta: {
    flex: 1,
    minWidth: 0,
  },
  deviceName: {
    color: "#202939",
    fontFamily: "Inter Tight !important",
    fontSize: "14px !important",
    fontWeight: "500 !important",
    lineHeight: "20px !important",
    // Device names are raw IPv6 strings, so they must be able to break.
    overflowWrap: "anywhere",
  },
  signoutBtn: {
    flexShrink: 0,
    alignSelf: "center !important",
    minWidth: "auto !important",
    padding: "4px 8px !important",
    color: "#274BF1 !important",
    fontFamily: "Inter Tight !important",
    fontSize: "13px !important",
    fontWeight: "500 !important",
    textTransform: "none !important",
    whiteSpace: "nowrap",
  },
  signOut: {
    fontFamily: "Inter Tight !important",
    color: "#646F86",
    fontSize: "14px !important",
    fontWeight: "400 !important",
    lineHeight: "20px !important",
  },
}));

export default useStyles;
